import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { authService } from "@/services/authService";
import useToastStore from "@/components/Common/Toast/toastStore";

const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address"),
    // .required("Email is required"),

});

const ForgotPassword = () => {
  const { showToast } = useToastStore;
 // const navigate = useNavigate();

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await authService.forgotPassword(values.email);
      showToast({ message: "Password reset link has been sent to your email!", type: "success" });
    
    } catch (error) {
    
   
      if (error.response?.data) {
        const { errors, error: errorObj, message } = error.response.data;
        

        if (errors || errorObj) {
          // Handle structured error objects
          const errorMessages = Object.values(errors || errorObj).flat();
          errorMessages.forEach(msg => showToast({ message: msg, type: "error" }));
        } else if (message) {
          // Handle simple message error
          showToast({ message: message, type: "error" });
        }
      } else {
        // Handle generic errors
        showToast({ message: error.message || "Please enter a valid email address to reset your password", type: "error" });
      }
    } finally {
      setSubmitting(false);
    }
  };
    


  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-primary/10 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl w-full space-y-8 bg-card p-10 rounded-xl shadow-lg">
        <div className="-mx-4 flex flex-wrap items-center">
          <div className="w-full px-4 lg:w-1/2">
            <div className="text-center grayscale">
              <img
                src="https://cdn.tailgrids.com/2.0/image/application/images/forms/forms-10.svg"
                alt="illustration"
                className="mx-auto"
              />
            </div>
          </div>
          {/* Right side with illustration */}
          <div className="w-full px-4 lg:w-1/2">
            <div>
              <h2 className="mt-6 text-3xl font-extrabold text-foreground">App Trkr</h2>
              <p className="mt-2 text-sm text-foreground mb-8">
                Enter your email to reset your password
              </p>
            </div>

            <Formik
              initialValues={{
                email: "",
                password: "",
                rememberMe: false
              }}
              validationSchema={ForgotPasswordSchema}
              onSubmit={handleSubmit}
            >
              {({ errors, touched, isSubmitting, getFieldProps, values, setFieldValue }) => (
                <Form className="space-y-6">
                  <div className="rounded-md">
                    <div className="mb-4">
                      <label htmlFor="email" className="block text-sm font-medium text-foreground">
                        Email Address
                      </label>
                      <input
                        id="email"
                        type="email"
                        {...getFieldProps("email")}
                        className="mt-1 appearance-none relative block w-full px-3 py-2 border border-input bg-background text-foreground placeholder:text-muted-foreground/50 rounded-md focus:outline-none focus:ring-1 focus:ring-ring focus:border-input focus:z-10 sm:text-sm"
                        placeholder="Enter your email"
                      />
                      {touched.email && errors.email && (
                        <p className="mt-2 text-sm text-red-600">{errors.email}</p>
                      )}
                    </div>

                    
                  </div>

                  

                  <div>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand disabled:opacity-50 disabled:cursor-not-allowed transform transition-all duration-150 hover:scale-[1.02]"
                    >
                      {isSubmitting ? (
                        <span className="flex items-center">
                          <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          Submitting...
                        </span>
                      ) : (
                        "Get Link"
                      )}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
